import dayjs, { OpUnitType, QUnitType } from 'dayjs'

import 'react-day-picker/style.css'
import { GraphGranularity } from '../../../__generated__/graphql'
import { GRAPH_PERIOD_LENGTH } from '../../../env'

export const getAvailableGranularities = (
  startDate: dayjs.Dayjs,
  endDate: dayjs.Dayjs
): { disabled: boolean; granularity: GraphGranularity }[] => {
  const updatedEndDate = dayjs(endDate).endOf('day')

  const periods: Array<QUnitType | OpUnitType> = ['hour', 'day', 'week', 'month']

  const isValidPeriod = (period: QUnitType | OpUnitType): boolean =>
    Math.ceil(updatedEndDate.diff(startDate, period, true)) <= GRAPH_PERIOD_LENGTH

  const defaultGranularities = [{ disabled: false, granularity: GraphGranularity.Year }]

  const availaibleGranularities = periods.map((period) => {
    const isValid = isValidPeriod(period)
    const granularity = (period.charAt(0).toUpperCase() + period.toString().slice(1)) as GraphGranularity

    return { disabled: !isValid, granularity: granularity }
  })

  return availaibleGranularities.concat(defaultGranularities)
}
